"use client";

import React, { createContext, ReactNode, useContext, useState } from "react";

type WavesurferContextState = {
  playingUrl: string | undefined;
  setPlayingUrl: React.Dispatch<React.SetStateAction<string | undefined>>;
  togglePlay: (url: string) => void;
  stop: () => void;
};

const WavesurferContext = createContext<WavesurferContextState | undefined>(
  undefined,
);

export const useWavesurferContext = (): WavesurferContextState => {
  if (!WavesurferContext) {
    throw new Error("WavesurferContext is undefined");
  }

  return useContext(WavesurferContext)!;
};

const WavesurferProvider: React.FC<{ children: ReactNode }> = ({
  children,
}) => {
  const [playingUrl, setPlayingUrl] = useState<string>();

  const togglePlay = (url: string) => {
    if (playingUrl === url) {
      stop();
    } else {
      setPlayingUrl(url);
    }
  };

  const stop = () => {
    setPlayingUrl(undefined);
  };

  return (
    <WavesurferContext.Provider
      value={{ playingUrl, setPlayingUrl, togglePlay, stop }}
    >
      {children}
    </WavesurferContext.Provider>
  );
};

export default WavesurferProvider;
